import React, { useState } from 'react'
import api from '../lib/api'

export default function UpgradeModal({ isOpen, onClose, reason }) {
  const [loading, setLoading] = useState(null)

  if (!isOpen) return null

  const handleCheckout = async (plan) => {
    setLoading(plan)
    try {
      const res = await api.post('/billing/checkout', { plan })
      window.location.href = res.data.url
    } catch {
      alert('Failed to start checkout. Please try again.')
      setLoading(null)
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-surface border-[1.5px] border-ink shadow-lg w-full max-w-md mx-4 p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-extrabold text-ink">Upgrade to Premium</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-xl leading-none">&times;</button>
        </div>

        {reason && (
          <p className="text-sm text-gray-600 mb-4">
            Upgrade to Premium to {reason}.
          </p>
        )}

        <div className="space-y-3 mb-6">
          <div className="border border-gray-200 rounded-lg p-4">
            <div className="flex items-center justify-between mb-1">
              <span className="font-semibold text-gray-900">Monthly</span>
              <span className="text-lg font-bold text-gray-900">$3.99<span className="text-sm font-normal text-gray-500">/mo</span></span>
            </div>
            <p className="text-sm text-gray-500 mb-3">99 vehicles + PDF export + attachments + full share page</p>
            <button
              onClick={() => handleCheckout('monthly')}
              disabled={loading !== null}
              className="w-full py-2 px-4 text-sm font-bold text-white bg-accent rounded-md hover:bg-accent-dark disabled:opacity-50"
            >
              {loading === 'monthly' ? 'Redirecting...' : 'Subscribe Monthly'}
            </button>
          </div>

          <div className="border-2 border-accent rounded-lg p-4 relative">
            <span className="absolute -top-2.5 right-3 bg-accent text-white text-xs font-medium px-2 py-0.5">
              Save 23%
            </span>
            <div className="flex items-center justify-between mb-1">
              <span className="font-semibold text-gray-900">Yearly</span>
              <span className="text-lg font-bold text-gray-900">$36.99<span className="text-sm font-normal text-gray-500">/yr</span></span>
            </div>
            <p className="text-sm text-gray-500 mb-3">99 vehicles + PDF export + attachments + full share page</p>
            <button
              onClick={() => handleCheckout('yearly')}
              disabled={loading !== null}
              className="w-full py-2 px-4 text-sm font-bold text-white bg-accent rounded-md hover:bg-accent-dark disabled:opacity-50"
            >
              {loading === 'yearly' ? 'Redirecting...' : 'Subscribe Yearly'}
            </button>
          </div>
        </div>

        <button
          onClick={onClose}
          className="w-full py-2 text-sm text-gray-500 hover:text-gray-700"
        >
          Maybe later
        </button>
      </div>
    </div>
  )
}
